import { useEffect, useState } from 'react';
import { Colors, Text } from '@mercator-gcp/grout';

const loadingMessages = [
  'Agent is gathering information to provide the best response...',
  'Still thinking...',
  'Sit tight, almost done...',
  'Crunching data...',
  'Just a moment more...',
  'Almost there...',
];

const LoadingBubble = () => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prevIndex) => (prevIndex + 1) % loadingMessages.length);
    }, 8000);

    return () => clearInterval(interval);
  }, []);

  return <Text color={Colors.TextQuiet}>{loadingMessages[messageIndex]}</Text>;
};

export default LoadingBubble;
